import React from "react";
import { motion } from "framer-motion";

const AUTH_BG = "https://images.unsplash.com/photo-1591969851586-adbbd4accf81?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const AuthShell = ({ title, subtitle, children, compact }) => {
  const [site, setSite] = React.useState(null);
  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-settings`).then((r) => r.json()).then(setSite).catch(() => {});
  }, []);
  const bg = site?.background_url ? `${process.env.REACT_APP_BACKEND_URL}/api/site-media/bg` : AUTH_BG;  const logoSrc = site?.logo_url ? (site.logo_url.includes("/api/files/") ? `${process.env.REACT_APP_BACKEND_URL}/api/site-media/logo` : site.logo_url) : "/logo512.png";
  const gold = site?.primary_color || "#D4AF37";
  const bgFit = site?.bg_fit || "cover";
  const bgPos = site?.bg_position || "center";
  const bgSize = (site?.bg_scale && site.bg_scale !== 100) ? `${site.bg_scale}%` : bgFit;
  const bgDim = site?.bg_dim ?? 55;
  const h = title || site?.headline || "Step into the rhythm.";
  const sub = subtitle || site?.tagline || "Sign in to your Darkchata account.";
  return (
    <div className="min-h-[100dvh] max-w-md mx-auto relative flex flex-col justify-end overflow-hidden bg-black">
      {site && (
        <>
          <div className="absolute inset-0 transition-opacity duration-500" style={{ backgroundImage: `url(${bg})`, backgroundSize: bgSize, backgroundPosition: bgPos, backgroundRepeat: "no-repeat", backgroundColor: "#0D0B14" }} />
          <div className="absolute inset-0 bg-[#0D0B14]" style={{ opacity: bgDim / 100 }} />
        </>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0B14] via-[#0D0B14]/70 to-transparent" />
      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className={`relative z-10 px-7 ${compact ? "pb-6 pt-8" : "pb-10 pt-16"}`}>
        <img src={logoSrc} alt="Darkchata" data-testid="auth-logo" className={`rounded-2xl object-cover ${compact ? "w-12 h-12 mb-2" : "w-20 h-20 mb-4"}`} />
        <p className={`uppercase tracking-[0.3em] text-[#D4AF37] ${compact ? "text-[10px] mb-1" : "text-xs mb-3"}`} style={{ color: gold }}>Darkchata</p>
        <h1 className={`font-display font-bold tracking-tight leading-tight ${compact ? "text-2xl" : "text-4xl"}`}>{h}</h1>
        {sub && <p className={`text-[#A19DB0] mt-1 ${compact ? "text-xs" : "text-sm mt-2"}`}>{sub}</p>}
        <div className={`max-w-sm rounded-2xl bg-white/[0.04] backdrop-blur-2xl border border-[#D4AF37]/15 ring-1 ring-white/5 shadow-[0_8px_40px_-12px_rgba(0,0,0,0.7)] ${compact ? "mt-4 p-4" : "mt-7 p-5"}`}>{children}</div>
      </motion.div>
    </div>
  );
};

export const Field = ({ label, compact, ...props }) => (
  <div className={compact ? "mb-2.5" : "mb-4"}>
    <label className="text-xs text-[#A19DB0]">{label}</label>
    <input
      {...props}
      className={`w-full bg-transparent border-b border-white/20 focus:border-[#D4AF37] outline-none text-white placeholder:text-white/30 transition-colors ${compact ? "py-1.5 text-sm" : "py-2"}`}
    />
  </div>
);

export const GoogleButton = ({ compact, solo }) => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const go = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <>
      {!solo && (
        <div className={`flex items-center gap-3 ${compact ? "my-3" : "my-5"}`}>
          <div className="flex-1 h-px bg-white/10" />
          <span className="text-xs text-[#A19DB0]">or</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>
      )}
      <button type="button" onClick={go} data-testid="google-login-button"
        className={`w-full flex items-center justify-center gap-3 bg-white text-[#1a1424] font-semibold rounded-full active:scale-[0.98] transition-transform ${compact ? "py-2.5 text-sm" : "py-3.5"}`}>
        <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="" className="w-5 h-5" /> Continue with Google
      </button>
    </>
  );
};

export default function Login() {
  return (
    <AuthShell compact subtitle="Sign in or create your account with Google.">
      <GoogleButton compact solo />
    </AuthShell>
  );
}
